import React from 'react'
import { CustomerAdminAuditSnapshotV1, IAuditEventData } from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveSnapshots } from './utils'
import { DetailField } from './DetailField'
import { DetailArrayField } from './DetailArrayField'

interface CustomerAdminDetailsProps {
  eventData: IAuditEventData
}

export const CustomerAdminDetails: React.FunctionComponent<CustomerAdminDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    CustomerAdminAuditSnapshotV1
  >(eventData, nameof<CustomerAdminAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Name"
          showDiff={showDiff}
          original={originalSnapshot?.fullName}
          updated={updatedSnapshot?.fullName}
        />

        <DetailField
          label="Username"
          showDiff={showDiff}
          original={originalSnapshot?.username}
          updated={updatedSnapshot?.username}
        />

        <DetailField
          label="Phone"
          showDiff={showDiff}
          original={originalSnapshot?.phone}
          updated={updatedSnapshot?.phone}
        />

        <DetailField
          label="Email"
          showDiff={showDiff}
          original={originalSnapshot?.email}
          updated={updatedSnapshot?.email}
        />

        <DetailArrayField
          label="Authorized Agencies"
          showDiff={showDiff}
          original={Object.values(
            originalSnapshot?.authorizedLicensedAgencies ?? [],
          )}
          updated={Object.values(
            updatedSnapshot?.authorizedLicensedAgencies ?? [],
          )}
        />
      </Box>
    </React.Fragment>
  )
}
